module.exports = __webpack_public_path__ + "static/media/video-thumb-large.5471bf20.svg";